import { Link } from 'react-router-dom';

function LPCta() {
    return (
    <section className="py-24 bg-primary relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20"></div>

        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
            <h2 className="text-4xl md:text-5xl font-black text-white italic uppercase mb-6 tracking-tighter">Ready to take the <span className="text-accent-cyan">Checkered Flag?</span></h2>
            <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto font-medium">Join over 12,000 drivers today. Setup takes less than 2 minutes. Free to start, professional tools for those who want more.</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <button className="w-full sm:w-auto px-10 py-4 bg-white text-primary font-black rounded-lg uppercase tracking-wider text-lg hover:bg-slate-100 transition-all shadow-xl">Start Your Free Trial</button>
                <Link to="/subscription-plans"><button className="w-full sm:w-auto px-10 py-4 bg-transparent border-2 border-white/40 text-white font-black rounded-lg uppercase tracking-wider text-lg hover:bg-white/10 transition-all">View Pro Pricing</button></Link>
            </div>
        </div>
    </section>
    );
}

export default LPCta;